import LeftBar from './components/leftBar'
import Chat from './components/chat'
import RightBar from './components/rightBar'
import styled from 'styled-components'
import {useSearchParams} from 'react-router-dom'
import {CookiesService} from '../../services/Cookie.service'
import {useEffect, useState} from 'react'
import {perguntaInicialDoChat} from '../TrilhaGuru/ponteConsulta'
import ReactGA from 'react-ga4'
import SystemStatusBanner from '../../globalComponents/SystemStatusBanner'

const Page = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden !important;
`

const Content = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
`

const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: left;
    align-self: flex-end;
    background-color: rgba(0, 0, 0, 0);
    padding: 20px 0;
    font-size: 12px;
    color: #7c7c7c;
    font-weight: 300;
    position: fixed;
    bottom: 0;

    font-family: 'Roboto', sans-serif;
    margin-left: 20vw;

    @media (max-width: 1590px) {
        margin-left: 25%;
    }

    @media (max-width: 1120px) {
        margin-left: 30%;
    }
`

export default function Home() {
    // A URL pode chegar com uma pergunta para PRÉ-PREENCHER o input do chat —
    // e nada mais: não envia, não consome crédito. É o que a ponte "Aprofundar
    // em uma Consulta" da Trilha do Guru usa ao abrir esta tela em aba nova.
    // `?consulta=<id>` é uma referência a um texto guardado no localStorage
    // (o prompt completo não cabe numa query string); `?pergunta=` é o
    // transporte antigo, mantido. Sem nenhum dos dois — ou com uma referência
    // que não existe mais — o chat abre exatamente como sempre abriu.
    //
    // A leitura é feita em efeito, e não no corpo do componente, porque
    // consumir a referência APAGA a chave: é um efeito colateral, e ele
    // acontece uma vez só (a chave é de uso único; reabrir a aba não repõe o
    // texto).
    const [searchParams] = useSearchParams()
    const [perguntaInicial, setPerguntaInicial] = useState('')

    useEffect(() => {
        const pergunta = perguntaInicialDoChat(searchParams)
        if (pergunta) setPerguntaInicial(pergunta)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    ReactGA.send({
        hitType: 'pageview',
        page: '/',
        title: 'Home',
    })

    useEffect(() => {
        const cookieService = new CookiesService()
        const flag = cookieService.getFlag()
        let url

        if (flag?.includes('plano1')) {
            if (flag.includes('mensal')) {
                url = import.meta.env.VITE_URL_MENSAL_PLANO1
            } else {
                url = import.meta.env.VITE_URL_ANUAL_PLANO1
            }
        } else if (flag?.includes('plano2')) {
            if (flag.includes('mensal')) {
                url = import.meta.env.VITE_URL_MENSAL_PLANO2
            } else {
                url = import.meta.env.VITE_URL_ANUAL_PLANO2
            }
        }
        if (url) {
            window.location.href = url!
            cookieService.removeFlag()
        }
    }, [])

    return (
        <Page>
            <SystemStatusBanner />
            <Content>
                <LeftBar></LeftBar>
                <Chat perguntaInicial={perguntaInicial}></Chat>
                {/* <RightBar></RightBar> */}
            </Content>
        </Page>
    )
}
